import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { FatturaElettronicaPassivaFilterComponent } from './fattura-elettronica-passiva-filter';

export const FatturaElettronicaPassivaFilterModule: string = ng
    .module('fattura-elettronica-passiva-filter', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('fatturaElettronicaPassivaFilterComponent', FatturaElettronicaPassivaFilterComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pr/fattura-elettronica-passiva-filter/fattura-elettronica-passiva-filter.module.ts